import { React, useEffect, useState } from "react";
import { Header } from "./../Header";
import { Layout } from "./Layout";
import { Link } from "react-router-dom";
import { Sidebar } from "../Sidebar";
import axios from "axios";
import { base_url } from "../../context/Authcontext";

export const Withdrawreport = () => {
    const [isSidebar, setSidebar] = useState(false);
    const [withdrawHistory, setWithdrawHistory] = useState([]); // Initialize as an empty array
    const [loading, setLoading] = useState(true); // Add a loading state
    const [error, setError] = useState(null);   // Add an error state
    useEffect(() => {
      const fetchWithdrawlHistory = async () => {
          setLoading(true);
          setError(null);

          try {
              const res = await axios.post(
                  `${base_url}/api/webapi/withdraw/historyList`,
                  {},
                  {
                    withCredentials:true,
                    headers:{
                      'Content-Type': 'application/json',
                    }
                  }
              );

              console.log("Full response:", res); // Log the entire response for debugging

              if (res.data && res.data.withdrawList) { // Check both res.data and res.data.withdrawList
                  setWithdrawHistory(res.data.withdrawList);
              } else {
                console.error("Invalid response format:", res.data);
                setError("Invalid data format from the server."); // Set a specific error message
              }

          } catch (err) {
              console.error("Error fetching withdrawal history:", err);
              setError("A network error occurred. Please try again later."); // Network error
          } finally {
              setLoading(false);
          }
      };

      fetchWithdrawlHistory();
  }, [])

    if (loading) {
        return <div>Loading withdrawal history...</div>; // Display a loading message
    }

    if (error) {
        return <div>Error: {error}</div>; // Display an error message
    }

  
  return (
    <>
      {isSidebar && <Sidebar />}
      <Header isSidebar={isSidebar} setSidebar={setSidebar} />
      <div
        _ngcontent-hdd-c80=""
        className=""
      >
        {/* container-fluid content-wrapper margin-top-90 */}
        <div className="marquee">
          <marquee>
            Betfair exchange odds are under maintenance Bookmaker and Fancy odds
            are available to play.
          </marquee>
        </div>
        <app-reports _nghost-hdd-c162="" className="ng-star-inserted">
          <div _ngcontent-hdd-c162="" className="pcoded-main-container">
            <div
              _ngcontent-hdd-c162=""
              className="container-fluid pl-3 accounts-box"
            >
              <div _ngcontent-hdd-c162="" className="row account-tabs"  style={{ height:"620px"}}>
                
                <div
                  _ngcontent-oqs-c169=""
                  className="col-12 mt-5 px-1 centralized_css"
                >
                  <app-history-home _nghost-oqs-c183="">
                    <div _ngcontent-oqs-c183="">
                      <div
                        _ngcontent-oqs-c183=""
                        className="col-md-12 deposit-pad-mob"
                      >
                        <div
                          _ngcontent-oqs-c183=""
                          className="st_blog_detail withdraw_section"
                        >
                          <div
                            _ngcontent-oqs-c183=""
                            className="st_featured_thumb"
                          >
                            <div
                              _ngcontent-oqs-c183=""
                              className="depositTabsWrapper d-flex justify-content-center"
                            >
                              <div
                                _ngcontent-oqs-c183=""
                                routerlinkactive="activeTab"
                                className="st_hd1 activeTab"
                                tabIndex="0"
                              >
                                <span
                                  _ngcontent-oqs-c183=""
                                  style={{ right: "6px" }}
                                >
                                  Withdrawal History
                                </span>
                              </div>
                              <Link
                                to="/depositehistory"
                                _ngcontent-oqs-c183=""
                                routerlinkactive="activeTab"
                                className="st_hd1 "
                                tabIndex="0"
                              >
                                <span _ngcontent-oqs-c183="">
                                  Deposit History
                                </span>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <router-outlet _ngcontent-oqs-c183=""></router-outlet>
                      <app-deposit-history _nghost-oqs-c182="">
                        <div
                          _ngcontent-hdd-c162=""
                          className="search-table"
                          style={{ paddingTop: "50px" }}
                        >
                          <div
                            _ngcontent-hdd-c162=""
                            className="table-box no-more-tables"
                          >
                            <table
                              _ngcontent-hdd-c162=""
                              className="table-borderless"
                            >
                              <thead _ngcontent-hdd-c162="">
                                <tr _ngcontent-hdd-c162="">
                                  <th
                                    _ngcontent-hdd-c162=""
                                    className="text-left"
                                  >
                                     Amount
                                  </th>
                                  <th
                                    _ngcontent-hdd-c162=""
                                    className="text-center"
                                  >
                                     Time
                                  </th>
                                  <th
                                    _ngcontent-hdd-c162=""
                                    className="text-center"
                                  >
                                    Status
                                  </th>
                                </tr>
                              </thead>
                              <tbody _ngcontent-hdd-c162="">
    {withdrawHistory.map((withdrawal, index) => (
        <tr key={index} _ngcontent-hdd-c162="" className="xg-bet-tr">
            <td _ngcontent-hdd-c162="" className="text-left" data-title="Request Amount">
                {withdrawal.money} {/* Access the correct property: amount */}
            </td>
            <td _ngcontent-hdd-c162="" className="text-center" data-title="Request Time">
                {withdrawal.today} {/* Access the correct property: requestTime */}
            </td>
            <td _ngcontent-hdd-c162="" className="text-center text-white p-2" data-title="Status">
    <span _ngcontent-hdd-c162="" className={withdrawal.status === 0? "pending-status": withdrawal.status === 1? "approved-status": "rejected-status"}>
        {withdrawal.status === 0? "Pending": withdrawal.status === 1? "Approved": "Rejected"} {/* Display user-friendly text */}
    </span>
</td>
        </tr>
    ))}
</tbody>
                            </table>
                          </div>
                        </div>
                      </app-deposit-history>
                    </div>
                  </app-history-home>
                </div>
              </div>
            </div>
          </div>
        </app-reports>
      </div>
    </>
  );
};